import React from "react";
import icon from "../assets/apple-touch-icon.png";

const Logo = () => {
  return <img src={icon} alt="BVN Portal Logo" className="w-10 h-10" />;
};

export default Logo;
